var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "slide-show-container" }, [
    _c("img", { attrs: { src: _vm.items[_vm.counter].img } }),
    _vm._v(" "),
    _c("div", { staticClass: "caption" }, [
      _c("p", [
        _vm._v("\n      " + _vm._s(_vm.items[_vm.counter].title) + "\n    ")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "\n      " + _vm._s(_vm.items[_vm.counter].description) + "\n    "
        )
      ])
    ]),
    _vm._v(" "),
    _vm.items.length > 1
      ? _c("div", { staticClass: "counter" }, [
          _c("i", {
            staticClass: "fa fa-chevron-left",
            on: {
              click: function($event) {
                return _vm.next()
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "dots" },
            _vm._l(_vm.items.length, function(index) {
              return _c("div", {
                key: index,
                class: ["dot-item", { selected: index - 1 === _vm.counter }],
                on: {
                  click: function($event) {
                    return _vm.changeIndex(index - 1)
                  }
                }
              })
            }),
            0
          ),
          _vm._v(" "),
          _c("i", {
            staticClass: "fa fa-chevron-right",
            attrs: { disabled: "true" },
            on: {
              click: function($event) {
                return _vm.prev()
              }
            }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }